import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
export default class LineupReminderNotification extends Notification {
  icon() {
    return 'fas fa-users-cog';
  }
  href() {
    const season = this.attrs.notification.content() && this.attrs.notification.content().season || '2026-2027';
    return app.route('matchRatingsClassificationPredict', {
      season
    });
  }
  content() {
    return app.translator.trans('nagusi-match-ratings.forum.notification.lineup_reminder');
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/LineupReminderNotification', LineupReminderNotification);